import React, { useState, useEffect } from 'react';
import { Spin, Alert, Button } from 'antd';

const OAuthCallback: React.FC = () => {
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');
  const [message, setMessage] = useState('Procesando autenticación...');

  useEffect(() => {
    const processOAuthCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');

        console.log('Parámetros de callback OAuth:', { code, error, errorDescription });

        if (code) {
          if (window.opener && !window.opener.closed) {
            window.opener.postMessage({
              type: 'OAUTH_SUCCESS',
              code: code
            }, window.location.origin);
            setStatus('success');
            setMessage('Autenticado');
            
            setTimeout(() => {
              window.close();
            }, 1000);
          } else {
            setStatus('error');
            setMessage('Error');
          }
        } else if (error) {
          console.error('Error de OAuth:', error, errorDescription);
          if (window.opener && !window.opener.closed) {
            window.opener.postMessage({
              type: 'OAUTH_ERROR',
              error: errorDescription || error
            }, window.location.origin);
          }
          setStatus('error');
          setMessage(`Error de autenticación: ${errorDescription || error}`);
          
          setTimeout(() => {
            window.close();
          }, 3000);
        } else {
          setStatus('error');
          setMessage('Error: No se recibieron parámetros de autenticación válidos.');
        }
      } catch (error) {
        console.error('Error en callback OAuth:', error);
        setStatus('error');
        setMessage('Error inesperado en el proceso de autenticación.');
      }
    };

    processOAuthCallback();
  }, []);

  return (
    <div style={{ 
      padding: 40, 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        background: 'white',
        padding: 40,
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        minWidth: 400
      }}>
        {status === 'processing' && <Spin size="large" />}
        
        <div style={{ marginTop: 20 }}>
          <Alert
            message={message}
            type={status === 'processing' ? 'info' : status === 'success' ? 'success' : 'error'}
            showIcon
          />
        </div>
        
        {status === 'error' && (
          <Button 
            type="primary" 
            style={{ marginTop: 20 }}
            onClick={() => window.close()}
          >
            Cerrar Ventana
          </Button>
        )}
      </div>
    </div>
  );
};

export default OAuthCallback;